// extracted by mini-css-extract-plugin
module.exports = {"pageTitle":"Home_pageTitle__vvGpm","heroSliderContainer":"Home_heroSliderContainer__ws27d","featuredSection":"Home_featuredSection__OTVcF"};